import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { EntityType } from 'types';
import { submitCollect } from 'redux/track/actions';
import { selectTrackCounter } from 'redux/track/selectors';
import { useComponentMount } from 'utilities/hooks.util';

const ISeekPlant: React.FC = () => {
  const dispatch = useDispatch();
  const trackCounter = useSelector(selectTrackCounter);

  useEffect(() => {
    if (trackCounter > 0) {
      window.location.href = 'https://www.fireants.org.au/FACT';
    }
  }, [trackCounter]);

  useComponentMount(() => {
    dispatch(
      submitCollect({
        payload: null,
        type: EntityType.OPEN_FIRE_ANTS_LINK
      })
    );
  });

  return <></>;
};

export default ISeekPlant;
